(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('AreaController', AreaController);

    AreaController.$inject = ['$scope', '$log', '$state', 'AreaService', '$rootScope', '$translate', '$localStorage', 'AlertService'];

    function AreaController($scope, $log, $state, AreaService, $rootScope, $translate, $localStorage, AlertService) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.areas = [];

        // FUNCITONS PUBLIC
        vm.book = book;
        vm.pageLoaded = pageLoaded;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        loadAreaTiles();
        successAlert();

        return vm;

        function loadAreaTiles() {
            if ($localStorage.areaInformation !== undefined) {
                $log.debug('AreaController | Fetching area tiles from localStorage');
                vm.areas = $localStorage.areaInformation
            } else {
                AreaService.areaInfo().then(successAreas, error);
            }
        }

        function successAlert() {
            if ($localStorage.showSuccessAlert !== undefined && $localStorage.showSuccessAlert == true) {
                var successMsg = $translate.instant('area.addedToCart');
                AlertService.success(successMsg, {}, 'bottom right');
                delete $localStorage.showSuccessAlert;
            }
        }

        function book(type) {
            $log.debug('AreaController | Booking Area with Type: ' + type);
            if (type == 'Joint_Stand') {
                $log.debug('AreaController | goto jointstand');
                $state.go('jointstand');
            }
            if (type == 'Pavillion') {
                $log.debug('AreaController | goto pavillion');
                $state.go('pavillion');
            }
            if (type == 'Outdoor_area') {
                $log.debug('AreaController | goto outdoor');
                $state.go('outdoor');
            }
            if (type == 'Open_Space') {
                $log.debug('AreaController | goto open space');
                $state.go('openspace');
            }
            if (type == 'Outdoor_area_static') {
                $log.debug('AreaController | goto outdoorstatic');
                $state.go('outdoorstatic');
            }
        }

        function successAreas(response) {
            $log.debug('AreaController | Fetching area tiles', response.data);
            vm.areas = response.data;
            $localStorage.areaInformation = vm.areas;
        }

        function error(response) {
            $log.debug('AreaController | ERROR:', response.data);
        }

        function pageLoaded() {
            return (vm.areas.areas !== undefined && vm.areas.areas.length > 0);
        }
    }
})();
